export default __webpack_public_path__ + "static/logo-d4d09bb8937c906cc8e7c676f87eb675.svg";